var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRamsaLogoShortColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "RamsaMark",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "118.33 22.42 55.41 72.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 { fill: #bc190f; }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M153.86,79.8c-.38,0-.72.14-.99.41l-3.81,3.82,9.02,9.47h14.65l-13.24-13.7h-5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.44,90.72c-1.79,1.79-4.16,2.77-6.68,2.77-5.2,0-9.43-4.23-9.43-9.43v-38.26h10.38v35.95l13.09-13.12.1-.1c2.22-2.15,5.13-3.35,8.24-3.35h5.21c.52.02,1.05.02,1.56,0h.24c.34,0,.68-.05,1-.13,1.84-.44,3.19-2.1,3.19-4.07v-22.98c0-2.31-1.88-4.19-4.19-4.19h-20.82v-10.38h20.82c6.54,0,12.09,4.33,13.93,10.27.43,1.36.66,2.8.66,4.31v22.98c0,.52-.02,1.03-.08,1.54-.78,7.32-6.99,13.04-14.51,13.04h-1.37l-6.47.11-14.88,15.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "129.57 33.8 135.27 33.8 135.27 23.42 119.34 23.42 119.34 43.61 129.57 43.61 129.57 33.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRamsaLogoShortColored);
export default __webpack_public_path__ + "static/media/ramsa-logo-short-colored.cf7492cc9f026995e0e74fd76064015c.svg";
export { ForwardRef as ReactComponent };